import './summaryPanel.scss';

/*******************************************************************************
 * @ngdoc component
 * @name  csm.books.InitialSetup.dom.component:summaryPanel
 *
 * @param {object[]} items
 * List of summary item descriptors:
 *   * **`text`**   - Item text.
 *   * **`amount`** - Item amount.
 *   * **`bold`**   - Boldface text flag.
 *   * **`red`**    - Color text red flag.
 *   * **`indent`** - Indent text flag.
 * `null` value descriptors create a blank line.
 *
 * @description
 * Initial Setup summary component. Loads lines to display from
 * `AppServices.getSummary`.
 *******************************************************************************/
export const summaryPanelComponent = {
  bindings: { lines: '<' },
  transclude: true,
  template:
    '<div ng-transclude></div>' +
    '<div>' +
    '<div ng-repeat="line in $ctrl.lines track by $index">' +
    '<p ng-class="{space:!line}">' +
    '<span ng-if="line.indent" class="indent"></span>' +
    '<span ng-if="!!line.text" ng-class="{title:line.bold,error:line.red}" ng-bind="line.text"></span>' +
    '<span ng-if="line.hasOwnProperty(\'amount\')" class="amount" ng-bind="line.amount|currency:\'\':2"></span>' +
    '</p>' +
    '</div>' +
    '</div>',
  controller: [
    'AppServices',
    function (AppServices) {
      this.$onInit = () => this.lines = AppServices.getSummary();
    }
  ]
};
